import { State } from '../state';

export const companyCreator: State = {
    url: 'company-creator'
};
